export function getGridRowClass(index: number) {
  return index % 2 === 0 ? 'evenRow' : 'oddRow'
}
